<template>
    <div class="adNewAddPay_mask"  v-if="addOk">
    <el-card class="adNewAddPay_account">
        <div slot="header" class="clearfix" style="text-align:center;">
            <span style="line-height: 36px;">添加资源</span>
        </div>
        <div class="resourseContent"> 
            <p>
                <span class="col-lg-3">选择文件：</span>
                <el-upload
                    ref="upload"
                    class="col-lg-4"
                    action="http://upload.qiniu.com/"
                    :data="myForm"
                    method="post"
                    :on-preview="handlePreview"
                    name="file"
                    :on-remove="handleRemove"
                    :before-upload="handleBeforeUpload"
                    :on-success="handleSuccess"
                    :multiple="isMultiple"
                    :file-list="fileList">
                    <el-button size="small" type="primary">选择文件</el-button>
                </el-upload>
            </p>
            <div style="margin:-10px 0 0 92px;color: #ff0200;font-size: 13px;">图片大小低于1M;图片建议尺寸1280*141</div>
            <p>
                <span class="col-lg-3">资源路径：</span><span class="col-lg-4">{{img}}</span>
            </p>
            <p style="text-align:center;"><el-button type="success" @click="commit" style="width: 240px;">提交</el-button></p>
        </div>
        <span @click="boxColose" style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949"><i class="el-icon-close Danger"></i></span>
    </el-card>
    </div>
</template>
<script>
    import $ajax from '../../https/config'
    export default {
      props: ['addShow', 'curType'],
      data () {
        return {
          labelPosition: 'right',
          loading: false,
          fileList: [],
          fileNum: 0,
          form: {},
          name: '',
          title: '',
          content: '',
          img: '',
          isMultiple: true,
          token: ''
        }
      },
      computed: {
        addOk: function () {
          return this.addShow
        },
        myForm: {
          set: function (value) {
            this.form = value
          },
          get: function () {
            return this.form
          }
        }
      },
      created: function () {
        this.getUpToken()
      },
      methods: {
        boxColose () {
          this.fileNum = 0
          this.img = ''
          this.$emit('closeAddPay', false)
        },
        getUpToken () {
          var myUrl = 'http://platform.songzb.com:32000/qiniuToken/image'
          var _this = this
          $ajax.get(myUrl, '', '', function (res) {
            _this.form.token = res.uptoken
          }, function () {
          })
        },
        handlePreview (file) {
        },
        handleRemove (file, fileList) {
          this.fileNum = 0
          this.img = ''
        },
        handleBeforeUpload (file) {
          var last, tType
          tType = 'image-'
          last = file.name.split('.').pop()
          if (this.fileNum === 1) {
            this.$message({
              type: 'error',
              message: '一次只能上传一张图片'
            })
            return Promise
          }
          if (last !== 'jpg' && last !== 'png' && last !== 'jpeg') {
            this.$message({
              type: 'error',
              message: '图片格式错误'
            })
            return false
          }
          if (file.size / 1024 > 1024) {
            this.$message({
              type: 'error',
              message: '图片大小超过500KB'
            })
            return false
          }
          this.fileNum = 1
          var str = tType + (new Date().getTime()) + Math.ceil(Math.random() * 10) + '.' + last
          this.form.key = str
        },
        handleSuccess (response, file, fileList) {
          var type = 'image'
          this.img = 'http://' + type + '.songzb.com/' + response.key
        },
        commit () {
          var that = this
          var params = {
            imageUrl: that.img
          }
          if (this.fileNum === 0) {
            that.$message({
              type: 'error',
              message: '请选择要上传的资源！'
            })
            return
          }
          $ajax.post('/device/addDeviceProcessImg', params, 'headers', function (res) {
            if (res.resultStatus === true) {
              that.$message({
                type: 'success',
                message: '添加资源成功！'
              })
              that.boxColose()
            }
          }, function () {
          })
        }
      }
    }
</script>
<style lang="scss">
  .adNewAddPay_mask {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 100;
      text-align: center;
  
  .adNewAddPay_account {
    min-height: 310px;
    width: 500px;
    top: 26%;
    left: 48%;
    z-index: 101;
    margin-left: -200px;
    position: fixed;

    .el-card__header {
        padding: 10px
    }
    .el-tabs__header {
        margin-bottom: 0;
    }
    .resourseContent {
        text-align: left;
    }
    .col-lg-3 {
        width: 20%;
        display: inline-block;
        font-weight: 700;
        color: #777;
        vertical-align: top;
    }
    .col-lg-4 {
        width: 72%;
        display: inline-block;

        textarea {
          height: 120px;
        }
    }

  }
  }
</style> 


// WEBPACK FOOTER //
// src/page/adMgr/adNewAddPay.vue